module.exports = __webpack_public_path__ + "img/studywayIcon5.c4df1a32.png";